export const MAX_SUGGESTIONS = 5;
export const MAX_ARTWORKS = 9;
export const MAX_COLLECTIONS = 5;
export const DEBOUNCE_TIME = 500;
export const RECENT_SEARCH_LC = 'recent_searches';
export const PLACEHOLDER_TEXT = 'Search for designs';
export const ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const EXCLUDED_CHARS = /-|\+|_|\/|\\/g;
export const TOP_BRANDS = [
    {
        url: '/marvel',
        name: 'Marvel',
        image: 'logo_marvel_circle.png',
    },
    {
        url: '/star_wars',
        name: 'Star Wars',
        image: 'logo_star_wars_circle.png',
    },
    {
        url: '/licensed/witcher-3',
        name: 'Witcher 3',
        image: 'logo_witcher_circle.png',
    },
    {
        url: '/gwent',
        name: 'Gwent',
        image: 'logo_gwent_circle.png',
    },
    {
        url: '/worldofwarships',
        name: 'World of Warships',
        image: 'logo_world_of_warships_circle.png',
    },
    {
        url: '/falloutgame',
        name: 'Fallout',
        image: 'logo_fallout_circle.png',
    },
];
export const POPULAR_LINKS = [
    {
        link: '/browse-brands',
        image: 'https://static.displate.com/assets/images/menu/menu_brands.png',
        title: 'Comic/Games Worlds',
    },
    {
        link: '/limited-edition',
        image: 'https://static.displate.com/assets/images/menu/menu_limited_editions.png',
        title: 'Limited Editions',
    },
];
//# sourceMappingURL=constants.js.map